import { CustomPropertyType, EmployeeRecord } from "winslow-core";
import "./AppCustomPropertySettings.css";
import { AppCustomPropertySettingsShort } from "./AppCustomPropertySettingsShort";
import { CheckboxMultipleSettings, CheckboxSingleSettings, DateSettings, DropdownSettings, EmailSettings, EmployeeRecordSettings, FileSettings, LongSettings, NumberSettings, PhoneSettings, RadioSettings, RichSettings, ShortSettings } from "./customPropertyConfig";
import { AppCustomPropertySettingsLong } from "./AppCustomPropertySettingsLong";
import { AppCustomPropertySettingsCheckboxSingle } from "./AppCustomPropertySettingsCheckboxSingle";
import { AppCustomPropertySettingsCheckboxMultiple } from "./AppCustomPropertySettingsCheckboxMultiple";
import { AppCustomPropertySettingsPhone } from "./AppCustomPropertySettingsPhone";
import { AppCustomPropertySettingsNumber } from "./AppCustomPropertySettingsNumber";
import { AppCustomPropertySettingsDate } from "./AppCustomPropertySettingsDate";
import { AppCustomPropertySettingsRich } from "./AppCustomPropertySettingsRich";
import { AppCustomPropertySettingsFile } from "./AppCustomPropertySettingsFile";
import { AppCustomPropertySettingsDropdown } from "./AppCustomPropertySettingsDropdown";
import { AppCustomPropertySettingsRadio } from "./AppCustomPropertySettingsRadio";
import { AppCustomPropertySettingsEmail } from "./AppCustomPropertySettingsEmail";
import { AppCustomPropertySettingsEmployeeRecord } from "./AppCustomPropertySettingsEmployeeRecord";

type AppCustomPropertySettingsProps = {
    type: CustomPropertyType;
    settings: any;
    onChange: (settings: any) => void;
}

export const AppCustomPropertySettings = ({type, settings, onChange} : AppCustomPropertySettingsProps) => {
    return (
        <>
            {(()=> {
                switch (type) {
                    case CustomPropertyType.SHORT:
                        return (
                            <AppCustomPropertySettingsShort 
                                settings={settings as ShortSettings}
                                onChange={(newSettings: ShortSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.LONG:
                        return (
                            <AppCustomPropertySettingsLong 
                                settings={settings as LongSettings}
                                onChange={(newSettings: LongSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.EMAIL:
                        return (
                            <AppCustomPropertySettingsEmail 
                                settings={settings as EmailSettings}
                                onChange={(newSettings: EmailSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.EMPLOYEE_RECORD:
                        return (
                            <AppCustomPropertySettingsEmployeeRecord
                                settings={settings as EmployeeRecordSettings}
                                onChange={(newSettings: EmployeeRecordSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    
                    // case CustomPropertyType.EMAIL:
                    //     return <AppCustomPropertySettingsShort />
                    //     break;
                    // case CustomPropertyType.WEBSITE:
                    //     return <AppCustomPropertySettingsShort />
                    //     break;
                    case CustomPropertyType.CHECKBOX_SINGLE:
                        return (
                            <AppCustomPropertySettingsCheckboxSingle
                                settings={settings as CheckboxSingleSettings}
                                onChange={(newSettings: CheckboxSingleSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.CHECKBOX_MULTIPLE:
                        return (
                            <AppCustomPropertySettingsCheckboxMultiple 
                                settings={settings as CheckboxMultipleSettings}
                                onChange={(newSettings: CheckboxMultipleSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.PHONE:
                        return (
                            <AppCustomPropertySettingsPhone 
                                settings={settings as PhoneSettings}
                                onChange={(newSettings: PhoneSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.NUMBER:
                        return (
                            <AppCustomPropertySettingsNumber
                                settings={settings as NumberSettings}
                                onChange={(newSettings: NumberSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.DATE:
                        return (
                            <AppCustomPropertySettingsDate 
                                settings={settings as DateSettings}
                                onChange={(newSettings: DateSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.RICH:
                        return (
                            <AppCustomPropertySettingsRich 
                                settings={settings as RichSettings}
                                onChange={(newSettings: RichSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.FILE:
                        return (
                            <AppCustomPropertySettingsFile 
                                settings={settings as FileSettings}
                                onChange={(newSettings: FileSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.DROPDOWN:
                        return (
                            <AppCustomPropertySettingsDropdown 
                                settings={settings as DropdownSettings}
                                onChange={(newSettings: DropdownSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    case CustomPropertyType.RADIO:
                        return (
                            <AppCustomPropertySettingsRadio 
                                settings={settings as RadioSettings}
                                onChange={(newSettings: RadioSettings) => {
                                    onChange(newSettings);
                                }}
                            />
                        )
                        break;
                    default:
                        return <div>Settings not available for this type</div>                 

                }
            })()}
        </>
    )
}
